Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.DECIMAL = (function () {

    function DECIMAL (field, entity) {

        Greenmile.PanelBuilder.Fields.ComplexField.apply(this, arguments);

    };

    return DECIMAL;

}());